import { createContext } from 'react';
import { Context } from '../models/Elements';

const CustomContext = createContext<Context>({
    auth: undefined,
    setAuth: () => {}
});
export default CustomContext;
